import { Link } from "react-router-dom";
import { Clock, CreditCard } from "lucide-react";
import { money, riskColor, STATUS_STYLE } from "../lib/api";

export const StatusBadge = ({ status, testid }) => (
  <span className={`px-2 py-0.5 border rounded-sm font-mono text-[10px] uppercase tracking-[0.15em] ${STATUS_STYLE[status] || ""}`} data-testid={testid}>
    {status?.replace("_", " ")}
  </span>
);

const daysLeft = (due) => Math.ceil((new Date(due) - Date.now()) / 86400000);

const ACTION = { FIGHT: ["SUBMIT NOW", "var(--brand)"], FIGHT_WITH_ADDITIONAL_EVIDENCE: ["ADD EVIDENCE", "#FFB800"], ACCEPT: ["ACCEPT / REFUND", "#F87171"] };

export const DisputeCard = ({ d, intel, delay = 0 }) => {
  const left = daysLeft(d.due_by);
  const open = ["needs_response", "under_review"].includes(d.status);
  return (
    <Link to={`/app/disputes/${d.id}`} className="panel panel-hover block p-5 rise" style={{ animationDelay: `${delay}ms` }} data-testid={`dispute-card-${d.id}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="font-mono text-[11px] text-white/35">{d.id}</p>
          <p className="font-medium mt-1">{d.customer_name}</p>
        </div>
        <StatusBadge status={d.status} testid={`dispute-status-${d.id}`} />
      </div>
      <p className="font-mono text-2xl font-bold tabular mt-4">{money(d.amount)}</p>
      <p className="text-xs text-white/45 mt-1 truncate">{d.reason_label}</p>
      {intel && d.status === "lost" && (
        <div className="flex items-center gap-2 mt-3 font-mono text-[10px]" data-testid={`dispute-appeal-${d.id}`}>
          <span className="px-1.5 py-0.5 border" style={{ borderColor: intel.appeal_recommended ? "var(--brand)" : "#555", color: intel.appeal_recommended ? "#CCFF00" : "#888" }}>
            {intel.appeal_recommended ? "APPEAL" : "APPEAL?"} · {intel.appeal_rate}% REVERSAL
          </span>
        </div>
      )}
      {intel && open && (
        <div className="flex items-center gap-2 mt-3 font-mono text-[10px]" data-testid={`dispute-intel-${d.id}`}>
          <span className="text-white/70">WIN <b className="text-brand">{intel.predicted_win}%</b></span>
          <span className="px-1.5 py-0.5 border" style={{ borderColor: ACTION[intel.recommendation][1], color: ACTION[intel.recommendation][1] }}>{ACTION[intel.recommendation][0]}</span>
          {intel.ready && <span className="text-accent2">READY</span>}
        </div>
      )}
      <div className="flex items-center justify-between mt-5 pt-4 border-t border-line font-mono text-[11px]">
        <span className="flex items-center gap-1.5 text-white/45">
          <CreditCard className="w-3 h-3" /> {d.network?.toUpperCase()} · {d.issuer_bank}
        </span>
        {open ? (
          <span className={`flex items-center gap-1 ${left <= 3 ? "text-[#F87171]" : "text-[#FFB800]"}`}>
            <Clock className="w-3 h-3" /> {Math.max(left, 0)}d
          </span>
        ) : (
          <span style={{ color: riskColor(d.risk_score) }}>risk {d.risk_score}</span>
        )}
      </div>
    </Link>
  );
};
